<template>
  <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;height:100%;" class="filters">
    <v-layout row>
      <v-flex d-flex md2>
        <v-card>
          <v-card-title primary class="title" style="height:5%;width:100%;padding-top:5px;padding-bottom:5px;">Filters</v-card-title>
          <v-card-actions fill-height style="display: block">
            <v-layout row v-for="field in filterFields" :key="field" style="width: 100%; margin: 0; padding: 0;">
              <v-flex v-if="field.options.length > 1" style="padding-top: 1rem; padding-bottom: 1rem">
                <v-layout column>
                  <v-layout row>
                    <v-autocomplete v-model="models[field.title]" name="" id="" :items="field.options" multiple :label="field.title" @change="listChanged(field.title)" clearable="true">
                    </v-autocomplete>
                  </v-layout>
                </v-layout>
              </v-flex>
              <v-flex v-else-if="field.options.length == 1" style="padding-top: 1rem; padding-bottom: 2rem; height: 32px">
                <v-layout column>
                  <v-layout row>
                    <v-layout column style="margin-left: 0; margin-top: 4px; font-size: 16px;">
                      {{ field.title }}
                    </v-layout>
                    <v-layout column style="margin-top: 3px;">
                      <v-switch @change="switchChanged(field.title,field.options[0])"></v-switch>
                    </v-layout>
                  </v-layout>
                </v-layout>
              </v-flex>
              <v-flex v-else style="padding-top: 1rem; padding-bottom: 2rem;">
                <v-layout column>
                  <v-layout row style="font-size: 16px;">
                    {{ field.title }}
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex d-flex md10>
        <v-card>
          <v-card-title primary class="title" style="height:5%;width:100%;padding-top:5px;padding-bottom:5px;">Engine Types</v-card-title>
          <v-card-actions fill-height style="height:95%;width:100%;padding-top:0px;padding-bottom:0px;">
            <dx-data-grid
                class="grid"
                :data-source="customerGridFiltered"
                :show-column-lines="true"
                :show-row-lines="true"
                :show-borders="true"
                :word-wrap-enabled="true"
                :row-alternation-enabled="false"
                :column-auto-width="true"
                @cellClick="gridClick"
                @cellPrepared="cellPrepared"
                style="max-width: calc(81% - 10px); overflow-x: auto;"
            >
              <dx-column data-field="name" caption="Customer"/>
              <dx-column data-field="favorite" cell-template="favTemplate"/>
              <dx-column data-field="tickets" cell-template="ticketTemplate" caption="Open Tickets" alignment="left"/>
              <dx-column data-field="status"/>
              <dx-column data-field="engines" cell-template="enginesTemplate"/>
              <div slot="favTemplate" slot-scope="{ data }" style="display:flex;justify-content:center;align-items:center;">
                <img src="../assets/favorite.png" v-if="data.value">
              </div>
              <div slot="ticketTemplate" slot-scope="{ data }" style="display:flex;align-items:center;">
                <img src="../assets/ticket_dark.png" style="height:40px;width:40px;">
                <div style="padding-left:15px;width:100%;height:100%;font-size:24px;">{{ data.value }}</div>
              </div>
              <div slot="enginesTemplate" slot-scope="{ data }" style="display:flex;align-items:center;">
                <div v-for="eng in data.value" :key="eng" style="margin-right:30px;">
                  <v-layout row>
                    <img v-if="eng.color==0" src="../assets/colordotsgray.png" style="height:20px;width:20px;margin:5px;">
                    <img v-else-if="eng.color==10" src="../assets/colordotsorange.png" style="height:20px;width:20px;margin:5px;">
                    <img v-else-if="eng.color==20" src="../assets/colordotsred.png" style="height:20px;width:20px;margin:5px;">
                    <v-layout column>
                      <v-flex d-flex md6>{{ eng.engine }}</v-flex>
                      <v-flex d-flex md6>{{ eng.vessel }}</v-flex>
                    </v-layout>
                  </v-layout>
                </div>
              </div>
            </dx-data-grid>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';
import axios from 'axios';
import {store} from "../main.js";

export default {
  name: "CustomersOverview",
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxScrolling
  },
  data() {
    return {
      filterFields: [],
      models: {},
      customerGridFiltered: [],
      customerGridAll: [],
      appliedFilters: {
        'Control System': [],
        'Fuel Type': [],
        'Engine Type': [],
        'Open Tickets': [],
        'Engine KPI': [],
      }
    }
  },
  props: {
    customersData: Array,
    active: Boolean
  },
  computed: {},
  created() {
    axios.post(store.config.api_location + '/GetCustomerFilters/').then(
        (response) => {
          if (response.status === 200) {
            this.filterFields = response.data.data;
          }
        },
        (error) => {
        }
    );
  },
  mounted() {
    this.setData();
  },
  methods: {
    gridClick(e) {
      if (e.column.dataField == "name" && e.rowType != "header") {
        this.$router.push({'path': `/customers/${e.value}`})
      }
    },
    cellPrepared(e) {
      if (e.column.dataField == "name" && e.rowType != "header") {
        e.cellElement.classList.add('clickable');
      }
    },
    filter() {
      var filters = this.appliedFilters,
          filterCount = Object.keys(filters).reduce(function (r, k) {
            return r.concat(filters[k]);
          }, []);

      if (filterCount.length < 1) {
        this.customerGridFiltered = this.customerGridAll;
      } else {
        let tmpFiltered = this.customerGridAll;

        for (var i in this.appliedFilters) {
          if (Object.prototype.hasOwnProperty.call(this.appliedFilters, i) && this.appliedFilters[i].length) {
            var filterValues = this.appliedFilters[i],
                filterResult = [];

            switch (i) {
              case 'Open Tickets':
                filterResult = tmpFiltered.filter(function (item) {
                  return item.tickets > 0;
                });
                break;
              default:
                for (let j = 0; j < filterValues.length; j++) {
                  var tmpEng;

                  filterResult = filterResult.concat(tmpFiltered.filter(function (item) {
                    switch (i) {
                      case 'Control System':
                        tmpEng = item.engines.map(function (eng) {
                          return eng.controlSystem;
                        });
                        break;
                      case 'Fuel Type':
                        tmpEng = item.engines.map(function (eng) {
                          return eng.fuelType;
                        });
                        break;
                      case 'Engine Type':
                        tmpEng = item.engines.map(function (eng) {
                          return eng.engine;
                        });
                        break;
                    }

                    return tmpEng.includes(filterValues[j]);
                  }));
                }
            }

            tmpFiltered = filterResult;
            this.customerGridFiltered = tmpFiltered;
          }
        }
      }
    },
    setData() {
      let companies = Object.keys(this.customersData);

      this.customerGridAll = [];

      for (let i = 0; i < companies.length; i++) {
        let customer = {
          name: companies[i],
          favorite: false,
          tickets: 0,
          status: this.customersData[companies[i]].status,
          engines: [],
        };

        let vessels = Object.keys(this.customersData[companies[i]].vessels);

        for (let j = 0; j < vessels.length; j++) {
          let vessName = vessels[j],
              engType = this.customersData[companies[i]].vessels[vessName].engineType,
              engines = Object.keys(this.customersData[companies[i]].vessels[vessName].engines);

          for (let e = 0; e < engines.length; e++) {
            let kpiClr = Number(this.customersData[companies[i]].vessels[vessName].engines[engines[e]].eng_KPI_color),
                clr;

            if (kpiClr == 0)
              clr = 'green';
            else if (kpiClr == 10)
              clr = 'yellow';
            else
              clr = 'red';

            customer.engines.push({
              engine: engType,
              vessel: vessName,
              color: kpiClr,
              controlSystem: store.engineAggr[engType]['controlSystem'],
              fuelType: store.engineAggr[engType]['fuelType'],
            });

            if (!!store.vesselTickets[vessName]) {
              customer.tickets += store.vesselTickets[vessName].open.length;
            }
          }
        }

        this.customerGridAll.push(customer);
      }

      this.customerGridFiltered = this.customerGridAll;
    },
    switchChanged(group, value) {
      if (this.appliedFilters[group].length < 1) {
        this.appliedFilters[group] = [value];
      } else {
        this.appliedFilters[group] = [];
      }

      this.filter();
    },
    listChanged(group) {
      var filters = [];

      for (var i in this.models[group]) {
        filters.push(this.models[group][i]);
      }

      this.appliedFilters[group] = filters;
      this.filter();
    }
  },
  watch: {
    customersData: function () {
      this.setData();
    }
  }
}
</script>

<style scoped></style>

<style>
.filters .v-input, .filters .v-input__slot, .filters .v-input--selection-controls__input {
  margin: 0 !important;
  padding: 0 !important;
}

.filters .v-input--switch {
  width: fit-content;
  position: relative;
  left: calc(100% - 44px);
}

.filters .v-label:not(.v-label--active) {
  color: black;
}
</style>
